import { z } from 'zod';

/** Form behind PATCH /platform/v1/organizations/:id. The slug never changes. */
export const profileSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, { error: 'organizations:validation.nameMin' })
    .max(120, { error: 'organizations:validation.nameMax' }),
  billingEmail: z.email({ error: 'organizations:validation.email' }).or(z.literal('')),
  notes: z.string().max(5000, { error: 'organizations:validation.notesMax' }),
});

export type ProfileValues = z.infer<typeof profileSchema>;

/** PATCH .../owner-invite: the corrected address of the invited owner. */
export const ownerEmailSchema = z.object({
  email: z.email({ error: 'organizations:validation.email' }),
});

export type OwnerEmailValues = z.infer<typeof ownerEmailSchema>;

/** POST .../support-session: why the operator needs to look. The tenant reads it in its audit log. */
export const supportReasonSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(3, { error: 'organizations:validation.reasonMin' })
    .max(500, { error: 'organizations:validation.reasonMax' }),
});

export type SupportReasonValues = z.infer<typeof supportReasonSchema>;

/** POST .../close. The reason is optional and lands in the audit log; `force` overrides open orders. */
export const closeSchema = z.object({
  reason: z.string().trim().max(500, { error: 'organizations:validation.reasonMax' }),
  force: z.boolean(),
});

export type CloseValues = z.infer<typeof closeSchema>;
